<script lang="ts">
  import UserInformation from "./user/UserInformation.svelte";
  import MobileNav from "./mobile-navigation/MobileNav.svelte";
  import DesktopNav from "./desktop-navigation/DesktopNav.svelte";
  import { activeClass, link, settings, t } from "../../../core";
  import { userInfo } from "./user/user-store";
  import StopInpersonation from "./user/StopInpersonation.svelte";
  import SubHeader from "./sub-header/SubHeader.svelte";
</script>

<header>
  <div class="content g-centered">
    <a
      use:link
      href="/"
      use:activeClass={"active-logo"}
      aria-label={settings?.siteTitle || "logotype"}
    >
      <svg class="logo" width="233" height="28" aria-label="logotype">
        <use xlink:href="#logo-color" />
      </svg>
    </a>

    <nav aria-label="desktop navigation" class="desktop-menu">
      <DesktopNav />
    </nav>

    <div aria-label="user intermation" class="user-information">
      <UserInformation />
    </div>

    <nav aria-label="mobile navigation" class="mobile-menu">
      <MobileNav />
    </nav>

    <StopInpersonation />
  </div>

</header>
<SubHeader />

<style lang="scss">
  .mobile-menu {
    @include md-hide;
    margin-left: auto;
  }
  .desktop-menu {
    @include md-show;
    margin-right: auto;
  }
  .user-information {
    @include md-show;
    margin-left: 20px;
    color: $key-color;
  }

  header {
    color: $key-color;
    background-color: $text-reverse-color;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.11);
  }

  .content {
    display: flex;
    align-items: center;
    padding-top: 20px;
    padding-bottom: 20px;

    @include md {
      padding-top: 40px;
      padding-bottom: 25px;
    }
  }

  .logo {
    height: 28px;
    margin-right: 46px;
  }
</style>
